import React, { useEffect, useState } from "react";
import { useCreateOrEditOrderMutation } from "../store/api/orderApi";
import "./order.css";
import {
  useGetCountriesQuery,
  useGetCurrenciesQuery,
  useGetRecipientsQuery,
  useGetCategoriesQuery,
} from "../store/api/recipientApi";
import TextField from "../components/TextField";
import SelectField from "../components/MySelect";
import FileUpload from "../components/FileUpload";
import {
  FaFileUpload
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import Button from "../components/Button";
import TutorialModal from "../components/TutorialModal";

const CreateOrderForm = () => {
  const {
    data: recipients,
    error: recipientsError,
    isLoading: isLoadingRecipients,
  } = useGetRecipientsQuery();
  const {
    data: countries,
    error: countriesError,
    isLoading: isLoadingCountries,
  } = useGetCountriesQuery();
  const {
    data: category,
    error: categoryError,
    isLoading: isLoadingCategory,
  } = useGetCategoriesQuery();
  const {
    data: currency,
    error: currencyError,
    isLoading: isLoadingCurrency,
  } = useGetCurrenciesQuery();
  const location = useLocation();
  const order = location.state;
  const [seccesscreate, setSeccessCreate] = useState(false);
  const [form, setForm] = useState({
    trackingNumber: "",
    cost: "",
    storeName: "",
    linkOrder: "",
    note: "",
    orderGuid: null,
    selectedCountry: { guid: "" },
    selectedReciever: { guid: "" },
    selectedCurrency: { guid: "" },
    selectedTarif: { guid: "" },
    selectedCategory: { guid: "" },
    invoiceFile: null,
    firstName: "", // ← добавляем сюда
  });

  const [inputErrors, setInputErrors] = useState({});

  const [createOrEditOrder, { isLoading }] = useCreateOrEditOrderMutation();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({
        ...prev,
        invoiceFile: {
          uri: URL.createObjectURL(file),
          name: file.name,
          type: file.type,
          raw: file,
        },
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Простейшая валидация для примера
    const errors = {};

    if (Object.keys(errors).length > 0) {
      setInputErrors(errors);
      return;
    }

    if (!form.trackingNumber) {
      alert("❌ Поле трек-номер не должно быть пустым.");

      return
    }

    if (!form?.selectedCountry?.guid) {
      alert("❌ Поле страна не должно быть пустым.");

      return
    }


    const formData = new FormData();
    formData.append("first_name", form.firstName);
    formData.append("tracking_number", form.trackingNumber);
    formData.append("amount", form.cost);
    formData.append("shop", form.storeName);
    formData.append("description", form.note);
    formData.append("order_guid", form.orderGuid);
    formData.append("country_guid", form.selectedCountry.guid);
    formData.append("reciever_guid", form.selectedReciever.guid);
    formData.append("currency_guid", form.selectedCurrency.guid);
    formData.append("tarif_guid", form.selectedTarif.guid);
    formData.append("with_box", form.with_box);
    formData.append("category_guid", form.selectedCategory.guid);
    if (form.invoiceFile?.raw) {
      formData.append("invoice", form.invoiceFile.raw);
    }

    try {
      const result = await createOrEditOrder(formData).unwrap();
      console.log(result);
      setSeccessCreate((state) => true);
    } catch (err) {
      const { data } = err;
      alert("❌ Ошибка при создании заказа: " + data.message);
    }
  };

  useEffect(() => {
    setForm(state => ({ ...state, ...order }))
  }, [order])

  return (
    <div className="ordform-container">
      <TutorialModal
        isOpen={seccesscreate}
        onClose={() => {
          setSeccessCreate((state) => !state);
        }}
        title="Заказ успешно создан"
        description=""
      >
        <img src="success.png" alt="" />
      </TutorialModal>
      <h2 className="ordform-header">
        Создание заказа{" "}

      </h2>
      <form onSubmit={handleSubmit} className="ordform-space">
        <div className="ordform-group">
          {isLoadingRecipients ? (
            <div className="ordform-loading">Загрузка...</div>
          ) : recipientsError ? (
            <div className="ordform-error">Ошибка загрузки</div>
          ) : (
            <SelectField
              label="Получатель"
              value={form.selectedReciever.guid}
              onChange={(e) =>
                setForm({
                  ...form,
                  selectedReciever: { guid: e.target.value },
                })
              }
              placeholder="Выберите получателя"
              options={recipients.map((r, i) => {
                if (i == 0 && (r.name == " " || !r.name == "")) {
                  return {
                    value: r.guid,
                    label: "Я",
                  };
                }
                return {
                  value: r.guid,
                  label: r.name,
                };
              })}
              defaultValue=""
              error={inputErrors.selectedReciever}
            />
          )}
        </div>

        {/* остальные поля формы (страна, валюта, категория, трек-номер, стоимость, магазин, ссылка, описание, файл) остаются без изменений */}
        <div className="ordform-group">
          {isLoadingCountries ? (
            <div className="ordform-loading">Загрузка...</div>
          ) : countriesError ? (
            <div className="ordform-error">Ошибка загрузки</div>
          ) : (
            <SelectField
              label="Страна"
              value={form.selectedCountry.guid}
              onChange={(e) =>
                setForm({
                  ...form,
                  selectedCountry: { guid: e.target.value },
                })
              }
              placeholder="Выберите страну"
              options={countries.map((c) => ({
                value: c.guid,
                label: c.country,
              }))}
              defaultValue=""
              error={inputErrors?.selectedCountry}
            />
          )}
        </div>

        <div className="ordform-group">
          {isLoadingCategory ? (
            <div className="ordform-loading">Загрузка...</div>
          ) : categoryError ? (
            <div className="ordform-error">Ошибка загрузки</div>
          ) : (
            <SelectField
              label="Категория"
              value={form.selectedCategory.guid}
              onChange={(e) =>
                setForm({
                  ...form,
                  selectedCategory: { guid: e.target.value },
                })
              }
              placeholder="Выберите категорию"
              options={category.map((c) => ({
                value: c.guid,
                label: c.name,
              }))}
              defaultValue=""
              error={inputErrors?.selectedCategory}
            />
          )}
        </div>

        <div className="ordform-group">
          <TextField
            label="Трек-номер"
            type="text"
            value={form.trackingNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
              setForm({ ...form, trackingNumber: value });
            }}
            placeholder="123ABC456"
            error={inputErrors?.trackingNumber}
          />
        </div>

        <div className="ordform-group">
          {isLoadingCurrency ? (
            <div className="ordform-loading">Загрузка...</div>
          ) : currencyError ? (
            <div className="ordform-error">Ошибка загрузки</div>
          ) : (
            <SelectField
              label="Валюта"
              value={form.selectedCurrency.guid}
              onChange={(e) =>
                setForm({
                  ...form,
                  selectedCurrency: { guid: e.target.value },
                })
              }
              placeholder="Выберите валюту"
              options={currency.map((c) => ({
                value: c.guid,
                label: c.name,
              }))}
              defaultValue=""
              error={inputErrors?.selectedCurrency}
            />
          )}
        </div>

        <div className="ordform-group">
          <TextField
            label="Стоимость"
            type="number"
            value={form.cost}
            onChange={(e) => setForm({ ...form, cost: e.target.value })}
            placeholder="1000"
            error={inputErrors?.cost}
          />
        </div>

        <div className="ordform-group">
          <TextField
            label="Магазин"
            type="text"
            value={form.storeName}
            onChange={(e) => setForm({ ...form, storeName: e.target.value })}
            placeholder="Amazon, eBay..."
            error={inputErrors?.storeName}
          />
        </div>
        <div className="ordform-group">
          <FileUpload
            label="Файл инвойса"
            icon={<FaFileUpload />}
            error={inputErrors.invoiceFile}
            onChange={handleFileChange}
          />
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 18 }}>
          <input
            type="checkbox"
            checked={form.with_box}
            style={{
              width: 18,
              height: 18
            }}
            onChange={(e) => setForm({
              ...form,
              with_box: e.target.checked,
            })}
          />
          Коробка нужна готов доплатить
        </label>
        <div className="ordform-group" style={{ width: "100%" }}>
          <label className="ordform-label">Комментарий/описание</label>
          <textarea
            value={form.note}
            onChange={(e) => setForm({ ...form, note: e.target.value })}
            className="ordform-textarea"
            placeholder="Комментарий к заказу"
          ></textarea>
        </div>
        {/* <div className="ordform-group">
                    <label className="ordform-label">Файл инвойса</label>
                    <input
                        type="file"
                        onChange={handleFileChange}
                        className="ordform-file-input"
                    />
                </div> */}
        {/* <button
                    type="submit"
                    disabled={isLoading}
                    className="ordform-button"
                >
                    {isLoading ? "Отправка..." : "Создать заказ"}
                </button> */}
        <div className="personal-bottom">
          <Button type="submit">Сохранить</Button>
        </div>
      </form>
    </div>
  );
};

export default CreateOrderForm;
